import React, { useState, useEffect } from 'react';
import { Form, Input, TimePicker, Select, Button, message } from 'antd';
import api from '../../../api/axios';

const COLORS = ['#667eea', '#f59e0b', '#22c55e', '#ef4444', '#a855f7', '#06b6d4', '#ec4899'];

function Add({ date, dateString, onClose, onSuccess }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    api.get('/employees').then(res => setEmployees(res.data?.data || [])).catch(() => message.error('Xodimlar ro\'yxati yuklanmadi'));
  }, []);

  const handleSubmit = (values) => {
    setLoading(true);
    const payload = {
      title: values.title,
      description: values.description || null,
      date: dateString || date?.format('YYYY-MM-DD'),
      start_time: values.time?.[0]?.format('HH:mm:ss') || null,
      end_time: values.time?.[1]?.format('HH:mm:ss') || null,
      color: values.color || '#667eea',
      employee_id: values.employee_id || null,
    };
    api.post('/tasks', payload)
      .then(() => { message.success('Vazifa yaratildi'); onSuccess?.(); })
      .catch(() => message.error('Xatolik yuz berdi'))
      .finally(() => setLoading(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
      <Form.Item name="title" label="Vazifa nomi" rules={[{ required: true, message: 'Nomini kiriting' }]}>
        <Input placeholder="Masalan: Zal tayyorlash" size="large" />
      </Form.Item>
      <Form.Item name="description" label="Tafsilot">
        <Input.TextArea rows={2} placeholder="Qo'shimcha ma'lumot..." />
      </Form.Item>
      <Form.Item name="time" label="Vaqt oralig'i">
        <TimePicker.RangePicker format="HH:mm" size="large" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="employee_id" label="Mas'ul xodim">
        <Select
          placeholder="Xodim tanlang (ixtiyoriy)"
          allowClear
          showSearch
          optionFilterProp="label"
          options={employees.map(e => ({ label: e.fullname || e.phone, value: e.id }))}
        />
      </Form.Item>
      <Form.Item name="color" label="Rang">
        <Select options={COLORS.map(c => ({ label: <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><div style={{ width: 16, height: 16, borderRadius: 4, background: c }} />{c}</div>, value: c }))} />
      </Form.Item>
      <Button type="primary" htmlType="submit" loading={loading} block size="large" style={{ borderRadius: 10, marginTop: 8 }}>
        Vazifa yaratish
      </Button>
    </Form>
  );
}

export default Add;